<template>
	<div class="main">
		<!-- 关于天宏达安 -->
		<div class="introduce">
			<el-image v-if="Index.about_img" :src="Index.about_img" class="ad" fit="fill"></el-image>
			<div class="info">
				<div class="title">
					{{$t('indexs.aouts')}}
				</div>
				<span></span>
				<!--  -->
				<div class="text" style="-webkit-line-clamp: 8;" v-if="$i18n.locale == 'zh'">
					<p v-html="Index.index_about"></p>
				</div>
				<div class="text" style="-webkit-line-clamp: 8;" v-else-if="$i18n.locale == 'en'">
					<p v-html="Index.y_index_about"></p>
				</div>
				<div class="text" style="-webkit-line-clamp: 8;" v-else-if="$i18n.locale == 'ru'">
					<p v-html="Index.e_index_about"></p>
				</div>
				<!-- 更多 -->
				<div class="link" @click="$router.push({ path:'/AboutUs/synopsis' })">
					{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
				</div>
			</div>
		</div>
		<!-- 统计 -->
		<div class="census">
			<el-image src="./static/image/head1.png" fit="cover"></el-image>
			<div class="info">
				<div class="li">
					<div class="num">
						1680+
					</div>
					<div class="title">
						{{$t('indexs.ke')}}
					</div>
					<span></span>
					<div class="text">
						{{$t('indexs.gao')}},<br>
						{{$t('indexs.pins')}}
					</div>
				</div>
				<div class="li">
					<div class="num">
						66+
					</div>
					<div class="title">
						{{$t('indexs.success')}}
					</div>
					<span></span>
					<div class="text">
						{{$t('indexs.shun')}}、<br>
						{{$t('indexs.tga')}}
					</div>
				</div>
				<div class="li">
					<div class="num">
						800+
					</div>
					<div class="title">
						{{$t('indexs.quan')}}
					</div>
					<span></span>
					<div class="text">
						{{$t('indexs.lc')}}+,<br>
						{{$t('indexs.zai')}}+
					</div>
				</div>
				<div class="li">
					<div class="num">
						600+
					</div>
					<div class="title">
						{{$t('indexs.zl')}}
					</div>
					<span></span>
					<div class="text">
						{{$t('indexs.zlsl')}}<br>
						{{$t('indexs.orzh')}}
					</div>
				</div>
			</div>
		</div>
		<!-- 服务范围 -->
		<div class="h_title">
			<el-image src="./static/image/tleft.png" fit="contain"></el-image>{{$t('indexs.fwfc')}}
			<el-image src="./static/image/tright.png" fit="contain"></el-image>
		</div>
		<div class="range">
			<div class="li" v-for='(val,key) in Index.service' :key="key">
				<el-image :src="val.image" fit="contain"></el-image>
				<span v-if="$i18n.locale == 'zh'">{{val.name}}</span>
				<span v-else-if="$i18n.locale == 'en'">{{val.y_name}}</span>
				<span v-else-if="$i18n.locale == 'ru'">{{val.e_name}}</span>
			</div>
		</div>
		<!-- 研发服务平台 -->
		<div class="h_title">
			<el-image src="./static/image/tleft.png" fit="contain"></el-image>
			<span>{{$t('nav.yan')}}</span>
			<el-image src="./static/image/tright.png" fit="contain"></el-image>
		</div>
		<el-carousel height="600px">
			<el-carousel-item  v-for="(val,key) in Index.research" :key="key">
				<div class="introduce" @click="$router.push({ path:'/service/cro?id='+val.id })">
					<el-image :src="val.image" class="ad" fit="fill"></el-image>
					<div class="info info2">
						<div class="title" v-if="$i18n.locale == 'zh'">
							{{val.title}}
						</div>
						<div class="title" v-if="$i18n.locale == 'en'">
							{{val.y_title}}
						</div>
						<div class="title" v-if="$i18n.locale == 'ru'">
							{{val.e_title}}
						</div>
						<span></span>
						
						<div class="text">
							<p v-if="$i18n.locale == 'zh'" v-html="val.content"> </p>
							<p v-if="$i18n.locale == 'en'" v-html="val.y_content"> </p>
							<p v-if="$i18n.locale == 'ru'" v-html="val.e_content"> </p>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
		<!-- 产品中心 -->
		<div class="product">
			<div class="h_title">
				<span></span>{{$t('nav.pro')}}<span></span>
			</div>
			<el-carousel height="530px">
				<el-carousel-item v-for="(item,index) in 1" :key="index">
					<div class="list">
						<div class="shop" v-for="(val,key) in Index.type" :key="key">
							<el-image :src="val.image" class="ad" fit="fill"></el-image>
							<div class="title" v-if="$i18n.locale == 'zh'">
								{{val.name}}
							</div>
							<div class="title" v-else-if="$i18n.locale == 'en'">
								{{val.y_name}}
							</div>
							<div class="title" v-else>
								{{val.e_name}}
							</div>

							<div class="text" v-if="$i18n.locale == 'zh'">
								{{val.desc}}
							</div>
							<div class="text" v-else-if="$i18n.locale == 'en'">
								{{val.y_desc}}
							</div>
							<div class="text" v-else>
								{{val.e_desc}}
							</div>
							<div class="link" @click="toProductDetail(val)">
								{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
							</div>
						</div>
						
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 文章 -->
		<div class="article">
			<!-- 科学研究 -->
			<div class="content" v-for="(val,key) in Index.news1" :key='key' >
				<div class="a_title"  >
					<span v-if="$i18n.locale == 'zh'">{{val.name}}</span>
					<span v-else-if="$i18n.locale == 'en'">{{val.y_name}}</span>
					<span v-else>{{val.e_name}}</span>
					<!-- <div class="link" @click="$router.push({ path:'/NewsCenter/news'+val.id });$router.go(0)" > -->
					<div class="link" @click="$router.push({ path:'/NewsCenter/news'+val.id });" >
						{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
					</div>
				</div>
				<div class="list" v-for="(val,key) in val.list" :key='key'>
					<el-image :src="val.image" class="news" fit="cover"></el-image>
					<div class="info">
						<div class="title" v-if="$i18n.locale == 'zh'">
							{{val.title}}
						</div>
						<div class="title" v-else-if="$i18n.locale == 'en'">
							{{val.y_title}}
						</div>
						<div class="title" v-else>
							{{val.e_title}}
						</div>

						<div class="text" v-html="val.content" v-if="$i18n.locale == 'zh'">
						</div>
						<div class="text" v-html="val.y_content" v-else-if="$i18n.locale == 'en'">
						</div>
						<div class="text" v-html="val.e_content" v-else>
						</div>

						<!-- <div class="link"  @click="$router.push({ path:'/NewsCenter/detail'+val.id });$router.go(0)" > -->
						<div class="link"  @click="$router.push({ path:'/NewsCenter/detail'+val.id });" >
							{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
						</div>
						<div class="time">
							{{val.create_time}}
						</div>
					</div>
				</div>
			</div>
			<!-- 公司新闻 -->
			<div class="content" v-for="(val,key) in Index.news2" :key='key' >
				<div class="a_title"  >
					<span v-if="$i18n.locale == 'zh'">{{val.name}}</span>
					<span v-else-if="$i18n.locale == 'en'">{{val.y_name}}</span>
					<span v-else>{{val.e_name}}</span>
					<!-- <div class="link" @click="$router.push({ path:'/NewsCenter/news'+val.id });$router.go(0)"> -->
					<div class="link" @click="$router.push({ path:'/NewsCenter/news'+val.id });">
						{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
					</div>
				</div>
				<div class="list" v-for="(val,key) in val.list" :key='key'>
					<el-image :src="val.image" class="news" fit="cover"></el-image>
					<div class="info">
						<div class="title" v-if="$i18n.locale == 'zh'">
							{{val.title}}
						</div>
						<div class="title" v-else-if="$i18n.locale == 'en'">
							{{val.y_title}}
						</div>
						<div class="title" v-else>
							{{val.e_title}}
						</div>
						
						<div class="text" v-html="val.content" v-if="$i18n.locale == 'zh'">
						</div>
						<div class="text" v-html="val.y_content" v-else-if="$i18n.locale == 'en'">
						</div>
						<div class="text" v-html="val.e_content" v-else>
						</div>
						<!-- <div class="link"  @click="$router.push({ path:'/NewsCenter/detail'+val.id });$router.go(0)"> -->
						<div class="link"  @click="$router.push({ path:'/NewsCenter/detail'+val.id });">
							{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
						</div>
						<div class="time">
							{{val.create_time}}
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="content">
				<div class="a_title">
					<span>文章发表</span>
					<div class="link">
						查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
					</div>
				</div>
				<div class="list">
					<el-image src="./static/image/head1.png" class="news" fit="cover"></el-image>
					<div class="info">
						<div class="title">
							新征程！天宏达安今日在香港联交所挂牌上市
						</div>
						<div class="text">
							2021年12月10日，天宏达安医药集团公开发行H股在香港联交所主板挂牌上市。随着H股的成功发行，正值A股上市五周年，实现“A+H”两地上市，再创前行之路的又一里程碑。过去二十余年...
						</div>
						<div class="link">
							查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
						</div>
						<div class="time">
							2021年12月30日
						</div>
					</div>
				</div>
				<div class="list">
					<el-image src="./static/image/head1.png" class="news" fit="cover"></el-image>
					<div class="info">
						<div class="title">
							新征程！天宏达安今日在香港联交所挂牌上市
						</div>
						<div class="text">
							2021年12月10日，天宏达安医药集团公开发行H股在香港联交所主板挂牌上市。随着H股的成功发行，正值A股上市五周年，实现“A+H”两地上市，再创前行之路的又一里程碑。过去二十余年...
						</div>
						<div class="link">
							查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
						</div>
						<div class="time">
							2021年12月30日
						</div>
					</div>
				</div>
				<div class="list">
					<el-image src="./static/image/head1.png" class="news" fit="cover"></el-image>
					<div class="info">
						<div class="title">
							新征程！天宏达安今日在香港联交所挂牌上市
						</div>
						<div class="text">
							2021年12月10日，天宏达安医药集团公开发行H股在香港联交所主板挂牌上市。随着H股的成功发行，正值A股上市五周年，实现“A+H”两地上市，再创前行之路的又一里程碑。过去二十余年...
						</div>
						<div class="link">
							查看更多<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
						</div>
						<div class="time">
							2021年12月30日
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<!-- 加入我们 -->
		<div class="add">
			<div class="a_title">
				<span>{{$t('nav.jabout')}}</span>
				<div class="link" @click="$router.push({ path:'/about' })">
					{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
				</div>
			</div>
			<div class="teams">
				<div class="team" v-for="(val,key) in Index.job" :key='key'>
					<div class="title" v-if="$i18n.locale == 'zh'">
						{{val.name}}
					</div>
					<div class="title" v-else-if="$i18n.locale == 'en'">
						{{val.y_name}}
					</div>
					<div class="title" v-else>
						{{val.e_name}}
					</div>

					<div class="tab" v-if="$i18n.locale == 'zh'">
						<div>{{val.department}}</div> <div>{{val.province}}</div>
					</div>
					<div class="tab" v-else-if="$i18n.locale == 'en'">
						<div>{{val.y_department}}</div> <div>{{val.y_province}}</div>
					</div>
					<div class="tab" v-else>
						<div>{{val.e_department}}</div> <div>{{val.e_province}}</div>
					</div>
					<div class="link" @click="$router.push({ path: '/about/aboutdetail?id='+ val.id })">
						{{$t('more')}}<el-image src="./static/image/lefticon.png" fit="contain"></el-image>
					</div>
				</div>
				
			</div>
		</div>
		<div class="contact">
			<p>{{$t('indexs.hese')}}</p>
			<p>{{$t('indexs.zqyp')}}</p>
			<div class="btn" @click="$router.push({ path: '/contact' })">
				{{$t('nav.contact')}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
        Index:{},
			}
		},
		mounted() {
			this.getIndex()
			// this.getlogin()
		},
		methods: {
			// 去详情页面
			toProductDetail(val){
				var name = {
					name:val.name,
					y_name:val.y_name,
					e_name:val.e_name,
				};
				// if(this.$i18n.locale == 'zh'){
				//  	name = val.name
				// }else if($i18n.locale == 'en'){
				// 	name = val.y_name
				// }else{
				// 	name = val.e_name
				// }
				// this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+name })
				this.$router.push({ path:'/product/productdetail?id='+val.id+'&name='+JSON.stringify(name) })

			},
			// index/type_new
			getlogin() {
				var that = this;
				this.$axios
					.post("api/login/index", {
						phone:'13121948541',
						pwd:'123456',
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							
							that.Index = ret.data.data;
							console.log( ret.data.data,'1111')
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
			//banner图
			getIndex() {
				var that = this;
				this.$axios
					.post("/api/index/index", {
						position:0,
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							
							that.Index = ret.data.data;
							console.log(ret.data.data,'首页数据')
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main {
		background-color: #FFFFFF;
		width: 100%;
		display: flex;
		align-items: center;
		flex-direction: column;
		// 研发服务平台
		.introduce {
			width: 1600px;
			height: 433px;
			margin: 60px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
            cursor: pointer;
			.ad {
				width: 800px;
				height: 433px;
			}

			.info {
				width: 800px;
				height: 433px;
				// height: 440px;
				padding-left: 40px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title {
					font-size: 30px;
					color: #004098;
					font-weight: bold;
				}

				span {
					display: block;
					width: 40px;
					height: 4px;
					background: #004098;
					margin-top: 20px;
				}

				.cro {
					font-size: 18px;
					color: #333;
					margin: 20px 0;
				}

				.text {
					// height: 300px;

							overflow: hidden;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 5;
					p {
						font-size: 16px;
						color: #999;
						text-indent: 2em;
					}

				}

				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}
			}

			.info2 {
				background-color: #F7F8FA;
				padding: 50px 40px;
			}
		}

		.census {
			width: 100%;
			height: 363px;
			position: relative;

			.el-image {
				width: 100%;
				height: 363px;
			}

			.info {
				width: 100%;
				height: 363px;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba($color: #004098, $alpha: 0.8);
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 200px;

				.li {
					width: 100%;
					color: #fff;
					display: flex;
					align-items: center;
					flex-direction: column;
					font-size: 16px;

					.num {
						font-size: 60px;
						font-weight: bold;
					}

					.title {
						font-size: 24px;
						margin-bottom: 10px;
					}

					span {
						display: block;
						width: 40px;
						height: 3px;
						background: #FFFFFF;
					}

					.text {
						margin-top: 20px;
						text-align: center;
					}
				}
			}
		}

		.h_title {
			font-size: 30px;
			color: #004098;
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 1600px;
			padding: 40px 0;
			font-weight: bold;

			.el-image {
				// width: 666px;
				// width: 650px;
				width: 625px;
				height: 13px;
			}
		}

		.range {
			width: 1600px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.li {
				font-size: 16px;
				color: #333;
				display: flex;
				align-items: center;
				flex-direction: column;

				.el-image {
					width: 70px;
					height: 70px;
					padding: 15px;
					margin-bottom: 15px;
					background-color: #004098;
				}
			}
		}

		.el-carousel {
			width: 1600px;
		}

		.product {
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-bottom: 60px;

			.list {
				width: 1600px;
				display: flex;
				align-items: flex-start;
				justify-content: space-between;

				.shop {
					width: 520px;
					height: 530px;
					background: #FFFFFF;
					padding: 20px;
					display: flex;
					flex-direction: column;

					.el-image {
						width: 480px;
						height: 360px;
					}

					.title {
						font-size: 20px;
						color: #333;
						margin: 15px 0;
					}

					.text {
						font-size: 16px;
						color: #666;
					}

					.link {
						font-size: 16px;
						color: #004098;
						display: flex;
						align-items: center;
						cursor: pointer;
						margin-top: 10px;

						.el-image {
							width: 16px;
							height: 16px;
							margin-left: 5px;
						}
					}
				}
			}
		}

		.article {
			width: 1600px;
			padding: 30px 0;
			display: flex;
			// align-items: center;
			justify-content: space-between;

			.content {
				display: flex;
				flex-direction: column;
				width: 780px;

				.link {
					font-size: 16px;
					color: #004098;
					display: flex;
					align-items: center;
					cursor: pointer;

					.el-image {
						width: 16px;
						height: 16px;
						margin-left: 5px;
					}
				}

				.a_title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 30px 0;

					span {
						font-size: 30px;
						font-weight: bold;
						color: #004098;
					}
				}

				.list {
					border: 1px solid #D8D8D8;
					padding: 20px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.news {
						width: 280px;
						height: 210px;
					}
					.info{
						width: 440px;
						height: 210px;
						display: flex;
						justify-content: space-between;
						flex-direction: column;
						.title{
							font-size: 20px;
							color: #333;
							font-weight: bold;
							
							overflow: hidden;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 3;
						}
						.text{
							font-size: 14px;
							color: #666;
							max-height: 80px;
							overflow: hidden;
							 display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 3;
						}
						.time{
							font-size: 12px;
							color: #999;
							// margin-top: 60px;
						}
					}
				}
			}
		}
		.add{
			width: 100%;
			background-color: #F7F8FA;
			display: flex;
			flex-direction: column;
			align-items: center;
			.link {
				font-size: 16px;
				color: #004098;
				display: flex;
				align-items: center;
				cursor: pointer;
			
				.el-image {
					width: 16px;
					height: 16px;
					margin-left: 5px;
				}
			}
			
			.a_title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 30px 0;
				width: 1600px;
			
				span {
					font-size: 30px;
					font-weight: bold;
					color: #004098;
				}
			}
			.teams{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 1600px;
				padding-bottom: 60px;
				.team{
					width: 385px;
					background: #FFFFFF;
					border: 1px solid #E5E8ED;
					.title{
						font-size: 22px;
						color: #333;
						padding-left: 30px;
						padding-top: 30px;
						font-weight: bold;
					}
					.tab{
						display: flex;
						align-items: center;
						margin: 10px 0;
						padding-left: 30px;
						div{
							height: 31px;
							padding: 0 10px;
							margin-right: 10px;
							display: flex;
							align-items: center;
							justify-content: center;
							background: #F9F9F9;
							border-radius: 2px;
							font-size: 16px;
							color: #666666;
						}
					}
					.link{
						padding: 10px 30px;
						border-top: 1px solid #F6F6F6;
						margin-top: 40px;
					}
				}
			}
		}
		.contact{
			width: 100%;
			height: 280px;
			background-color: #004098;
			display: flex;
			flex-direction: column;
			align-items: center;
			// padding-top: 60px;
			padding: 60px;
			color: #fff;
			p{
				color: #fff;
				font-size: 24px;
				white-space:pre-wrap;
			}
			.btn{
				width: 160px;
				height: 38px;
				border: 1px solid #FFFFFF;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 40px;
			}
		}
		.el-carousel-item .el-carousel__button{
			display: block;
			opacity: .48;
			width: 30px;
			height: 2px;
			background-color: #004098!important;
			border: none;
			outline: 0;
			padding: 0;
			margin: 0;
			cursor: pointer;
			-webkit-transition: .3s;
			transition: .3s;
		}
	}
		
</style>



// WEBPACK FOOTER //
// src/components/index.vue